import { usePathname, useSearchParams } from "next/navigation";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useCallback } from "react";
import { removeEmptyQueryParams, removeOuterQueryParams } from "./pages-paths";

interface IQueryItem {
  name: string;
  val: any;
}

export const useBlogPushQuery = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  
  const createQueryString = useCallback(
    (queryItems: IQueryItem[], resetPage: boolean) => {
      const params = new URLSearchParams(searchParams!);
      removeOuterQueryParams(params);
      queryItems.forEach((item) => params.set(item.name, item.val));
      if (params.has("page") && resetPage) params.set("page", "1");
      removeEmptyQueryParams(params);
      return params?.toString();
    },
    [searchParams]
  );

  const pushQueryToRouter = (query: IQueryItem[], resetPage = false) => {
    let targetPath = pathname;
    const isMainBlogPage = pathname.endsWith("/blog");

    if (!isMainBlogPage) {
      const parts = pathname.split("/blog/");
      if (parts.length === 2) {
        targetPath = parts[0] + "/blog";
      }
    }

    const newUrl = targetPath + "?" + createQueryString(query, resetPage);
    
    if (isMainBlogPage) {
      // Use pushState to avoid triggering a server fetch in Next.js App Router.
      window.history.pushState(null, '', newUrl);
    } else {
       router.push(newUrl);
    }
  };
  
  return { pushQueryToRouter };
};
